export default "__VITE_ASSET__7c9a8e59__"